import { browser, dev, version } from "$app/environment";

const { SMARTPARKS_CENTCOM_API_URI, SMARTPARKS_SENTRY_DSN, SMARTPARKS_SENTRY_ENV } = import.meta
  .env;

export const isBrowser = browser;

export const isServer = !isBrowser;

export const isDev = dev;

export const sentryEnv = SMARTPARKS_SENTRY_ENV;

export const sentryDsn = SMARTPARKS_SENTRY_DSN;

export const centcomApi = SMARTPARKS_CENTCOM_API_URI;

export const appVersion = version;

// Health Checks

if (centcomApi == null) {
  throw new Error("Configuration Error: SMARTPARKS_CENTCOM_API_URI must be defined.");
}
